import React from 'react';

const Error = () => {
    return ( 
        <h1>ERROR!</h1>
     );
}
 
export default Error;